import { Avatar, AvatarProps } from '@mui/material';
import { Client } from '@app/core/types/client';

interface Props extends Omit<AvatarProps, 'src' | 'alt' | 'children'> {
  readonly client: Client;
  readonly size?: number | string;
}

/**
 * Avatar component that displays a client's logo or falls back to the first letter of the client name
 */
export const ClientAvatar = (props: Props) => {
  const { client, size = 24, sx, ...rest } = props;
  const logoUrl = client.logoUrl || '';

  const sizeValue = typeof size === 'number' ? `${size}px` : size;
  const fontSize = typeof size === 'number' ? `${size * 0.3125}px` : '0.75rem';

  return (
    <Avatar
      src={logoUrl}
      alt={`${client.name} logo`}
      sx={{
        width: sizeValue,
        height: sizeValue,
        fontSize,
        border: '1px solid',
        borderColor: 'grey.400',
        ...sx,
      }}
      {...rest}
    >
      {client.name.charAt(0).toUpperCase()}
    </Avatar>
  );
};
